import { createLogger, createStore } from 'vuex'
import Cookie from 'js-cookie'
import { set, remove, get } from '../utils/Cache';
const modules = import.meta.glob("../views/**/**.vue");
// 图片
// function getImageUrl(name) {
//   return new URL(`../assets/nav_icons/${name}.svg`, import.meta.url).href
// }
import { getImageUrl}  from '../utils/AssetsImage';

export default createStore({
  state: {
    isCollapse:true,
    currentMenu:null,
    tabsList:[
      {
        label: '设备列表',
        path: '/device/device-list',
        name: 'device-List'
      }
    ],
    menu:[],
    UserInfo:'',
    token:'',
    uid:'',
    locations:[],
    devDetails:"",
    productRecord:"",
    receiveDataJson:'',
    mockApi:'',
    timeZone:''
  },
  mutations: { 
    updataIsCollapse(state) {
      state.isCollapse = !state.isCollapse
    },
    selectMenu(state, val) {
      // console.log('selectMenu', val);
      // state 是一个对象，val是Aside传过来的item
      // 判断
      // val.name == 'home' ? (state.currentMenu == null ) : (state.currentMenu = val)
      if (val.label == '设备管理') {
        state.currentMenu = null
      } else {
        state.currentMenu = val
        // 在 state.tabsList 中具有与 val.name 相同属性的项，
        // findIndex 会返回匹配项的索引值，如果没有匹配项，返回-1 
        let result = state.tabsList.findIndex(item => item.label === val.label)
        // 如果res = -1 ,没有找到匹配项，将val添加到tabList数组中。否则为''
        result == -1 ? state.tabsList.push(val) : ''
      }
      // console.log(state.currentMenu.label,val);
      // console.log('tabsList',state.tabsList);
    },
    closeTab(state, val) {
      console.log(state, val);
      let res = state.tabsList.findIndex(item => item.name === val.name)
      console.log(res);
      state.tabsList.splice(res, 1)
    },
    // 设置有哪些路由,获取菜单持久化保持
    setMenu(state, val) {
      // console.log('setMenu',state);
      // console.log('setMenu',val);
      const menuVal = val.map((item) => {
        return{
          // ...item,
          label: item.name,
          path: item.path,
          name: item.name,
          icon: getImageUrl(item.name),
          children: item.children
        }
      })
      state.menu = menuVal
      console.log('icon_menu',state.menu);
      // 存储val
      localStorage.setItem('menu', JSON.stringify(menuVal))
    },
    addMenu(state,router) {
      // 检查本地存储中存在 menu 数据
      if (!localStorage.getItem('menu')) {
        return
      }
      // 
      const menu = JSON.parse(localStorage.getItem('menu'))
      // console.log('Aside-menu',menu);
      // 本地存储 menu 赋值给 state.menu
      state.menu = menu
      // console.log('Aside_menu',state.menu);
      const list = [];

      menu.forEach(menuItem => {
        const parentItem = {
          path: menuItem.path, // 你的路径
          component: () => import('@/views/Main.vue'), // 你的组件路径
          name: menuItem.name,
          meta: { title: menuItem.name,permissions:menuItem.permissions},
          // children: menuItem.children,
          children: []
        };
        // console.log('parentItem',parentItem);
        menuItem.children.forEach(childItem => {
          // console.log('childItem',childItem);
          let childRoute = ''
          // 有 按钮权限 permissions
          if (childItem.children == 'null') {
            // console.log('child123',childItem.children);
          }
          if (childItem.children && childItem.children !== null) {
            // console.log('childRoute.children',childItem.children);
             childRoute = {
              path: childItem.path,
              name: childItem.name,
              meta: { title: childItem.name ,permissions:childItem.children.permissions},
              component: modules[`../views${childItem.path}.vue`],
              children: []
            }
          }
          else {
              childRoute = {
              path: childItem.path,
              name: childItem.name,
              meta: { title: childItem.name},
              component: modules[`../views${childItem.path}.vue`]
            };
          }
          // console.log('childRoute',childRoute);
          // console.log('childRoute111',childRoute);
          parentItem.children.push(childRoute);
          list.push(parentItem);
        });
      });
      // console.log('addMenu路由列表（list）',list);
      list.forEach(item => {
        // console.log('addMenu路由列表（item）',item);
        router.addRoute(item)
      })
      // console.log('addMenu路由列表（全部）',router.getRoutes())
    }, 



    // 退出清除
    cleanMenu(state) {
      state.menu = []
      localStorage.removeItem('menu')
    },
    // 设置 token 
    setToken(state,val) {
      state.token = val
      Cookie.set('token',val)
    },
    // 清除
    clearToken(state) {
      state.token = '',
      Cookie.remove('token')
    },
    // 获取token
    getToken(state) {
      // state.token = state.token || Cookie.get('token')
      // state.token = state.UserInfo.token
    },
    setUserInfo(state,val) {
      console.log(val);
      state.UserInfo = val
      set('UserInfo', val)
      state.token = val.token
      state.uid = val.uid
      console.log(state);
    },
    cleanOut(state) {
      state.currentMenu = null
      state.menu = [],
      state.UserInfo = null,
      remove('UserInfo')
      remove('menu')
    },
    // 密码修改后，更新token
    changeToken(state,val) {
      state.token = val
      state.UserInfo.token = val
    },

    // 传递设备参数
    getDevices(state,val) {
      if (val !== '') {
        console.log('getDevices:',"val is true");
      }
      state.record = val
    },
    checkProduct(state,val) {
      if (val !== '') {
        console.log('checkProduct:',"val is true");
      }
      state.product_list = val
    },
    setLocations(state,val) {
      state.locations = val
      console.log(state.locations);
    },
    setDeviceDetail(state,val) {
      if (val) {
        state.devDetails = val
      }
    },
    setDeviceInfo(state,val) {
      console.log('setDeviceInfo',val);
      if (val) {
        state.devInfo = val
        set('devInfo', val)
      } else {
        state.devInfo = ''
        remove('devInfo')
      }
    },
    setProductRecord(state,val){
      if (val) {
        state.productRecord = val
      }
    },
    setReceiveDataJson(state,val) {
      if (val) {
        state.receiveDataJson = val
      }
    },
    setAPI(state,val) {
      if (val) {
        state.mockApi = val
      }
    },
    setTimeZone(state,val) {
      console.log('setTimeZone',val);
      if (val) {
        state.timeZone = val
        set('setTimeZone',val) 
      }
    },
  }
})